import { cloneDeep } from "lodash-es";
import React from "react";
import { FeedbackButton } from "components/UI/Feedback";
import { useFeedbackRouting } from "./utils";
import { isMobileDevice } from "../../utils/mobile";

const isMobile = isMobileDevice();

const verseFeedbackLinkStyle = isMobile
  ? { display: "inline", marginRight: 6 }
  : {
      display: "inline",
      right: "calc(100% + 8px)",
      position: "absolute",
      marginTop: 6
    };

const VerseFeedbackLink = ({ verseId }: { verseId: string }) => {
  const { setFeedbackVerse } = useFeedbackRouting();

  return (
    <FeedbackButton
      filled
      size={isMobile ? 18 : 24}
      onClick={() => setFeedbackVerse(verseId)}
      style={verseFeedbackLinkStyle}
    />
  );
};

export function addVerseIconsToChapterContent(
  rawContent: any,
  rawSelectedVerseIds: any
) {
  if (rawSelectedVerseIds.length === 0) return rawContent;

  const content = cloneDeep(rawContent);
  const selectedVerseIds = [...rawSelectedVerseIds];

  const commentIconCordinates = content.reduce(
    (cordinateList: any, curr: any, contentIndex: any) => {
      const foundIndexes = [];

      if (curr.items && curr.items.length) {
        for (let itemIndex = 0; itemIndex < curr.items.length; itemIndex++) {
          const item = curr.items[itemIndex];

          if (!item.attrs || !item.attrs.verseId) continue;

          // see if item is related to the verses we're looking for
          const selectedVerseIndex = selectedVerseIds.indexOf(
            item.attrs.verseId
          );

          // bail if selected verse is not found
          if (selectedVerseIndex === -1) continue;

          // add cordinates of found verse
          selectedVerseIds.splice(selectedVerseIndex, 1);
          // remove from selectedVerseIds to stop searching for already found verses
          // array of selected verses should be empty by end of for loop
          foundIndexes.push([contentIndex, itemIndex, item.attrs.verseId]);
        }
      }

      // if we found something append the flattened results to main cordinates list
      if (foundIndexes.length) cordinateList.push(...foundIndexes);
      return cordinateList;
    },
    []
  );

  for (let [
    contentIndex,
    itemIndex,
    verseId
  ] of commentIconCordinates.reverse()) {
    content[contentIndex].items.splice(itemIndex, 0, {
      type: "component",
      component: <VerseFeedbackLink verseId={verseId} />
    });
  }
  return content;
}
